// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ComplianceResponseSchema } from './v1/complianceResponseSchema';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listCompliancePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listComplianceQueryParamsSchema = z.object({
  from: z.optional(z.string().date().describe("ISO date inclusive start of window (defaults to 30 days before `to`)")),
  to: z.optional(z.string().date().describe("ISO date inclusive end of window (defaults to today)")),
}).optional();

export const listComplianceHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Compliance metrics retrieved successfully
 */
export const listCompliance200Schema = z.lazy(() => v1ComplianceResponseSchema);

/**
 * @description Unauthorized
 */
export const listCompliance401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Forbidden
 */
export const listCompliance403Schema = z.lazy(() => v1ForbiddenErrorSchema);

export const listComplianceQueryResponseSchema = z.lazy(() => listCompliance200Schema);
